<template>
<div class="faq">
    <div v-for="(item, index) in faqs" :key="index" class="dropdown-faq" :class="{ active: activeIndex === index }">
        <div class="faq-title" :class="{ active: activeIndex === index }" @click="toggleFaq(index)">
            <div>{{ item.question }}</div>
            <img src="../assets/down-black.svg" alt="down" :class="{rotate: activeIndex===index}" loading="lazy">
        </div>

        <p v-if="activeIndex === index" class="content" v-html="item.answer">
        </p>
    </div>
</div>
</template>

<script>
export default {
    props: {
        faqs: {
            type: Array,
            required: true
        },
        defaultOpen: {
            type: Number,
            default: null
        }
    },
    data() {
        return {
            activeIndex: this.defaultOpen
        }
    },
    methods: {
        toggleFaq(index) {
            if (this.activeIndex === index) {
                this.activeIndex = null
            } else {
                this.activeIndex = index
            }
        }
    }
}
</script>
